module.exports = __webpack_public_path__ + "static/media/Top-grey.ffc14cc6.svg";